import { render, staticRenderFns } from "./ItsBaseTeamHistory.vue?vue&type=template&id=a522707a&scoped=true&"
import script from "./ItsBaseTeamHistory.vue?vue&type=script&lang=js&"
export * from "./ItsBaseTeamHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a522707a",
  null
  
)

export default component.exports